import { useModel as _useModel, defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import {
  BaseFormItem,
  BaseInput,
  BaseUpload,
  BaseTextContent,
  BaseTextTitle,
  BaseForm
} from 'xrk-components';
import { IndividualInfoDetailData } from '../../data-source/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'material',
  props: {
    "modelValue": {},
    "modelModifiers": {},
  },
  emits: ["update:modelValue"],
  setup(__props) {

const formData = _useModel<IndividualInfoDetailData & { fileList: any[] }>(__props, "modelValue");

const onFilePreview = v => {
  window.open(v.url);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(BaseTextTitle), null, {
      default: _withCtx(() => [
        _createTextVNode("提交材料")
      ]),
      _: 1
    }),
    _createVNode(_unref(BaseTextContent), null, {
      default: _withCtx(() => [
        _createVNode(_unref(BaseForm), {
          "label-position": "top",
          disabled: "",
          model: formData.value,
          "column-count": 4
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseFormItem), {
              label: "所属园区",
              prop: "businessParkName",
              rules: [
          {
            required: true,
            trigger: 'change',
            message: '请输入'
          }
        ]
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseInput), {
                  style: {"width":"100%"},
                  type: "text",
                  placeholder: "请输入",
                  modelValue: formData.value.businessParkName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.businessParkName) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BaseFormItem), {
              label: "补充说明",
              prop: "additionalRemark"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseInput), {
                  style: {"width":"100%"},
                  type: "textarea",
                  placeholder: "请输入",
                  rows: 3,
                  modelValue: formData.value.additionalRemark,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.additionalRemark) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BaseFormItem), {
              label: "个体户意向名",
              prop: "intentNameList"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseInput), {
                  style: {"width":"100%"},
                  type: "textarea",
                  placeholder: "请输入",
                  rows: 3,
                  "model-value": formData.value.intentNameList.join('、')
                }, null, 8, ["model-value"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BaseFormItem), {
              label: "其他材料",
              prop: "fileList"
            }, {
              default: _withCtx(() => [
                (!formData.value.isSkipFile)
                  ? (_openBlock(), _createBlock(_unref(BaseUpload), {
                      key: 0,
                      style: {"width":"100%"},
                      listType: "text",
                      btnText: "添加文件",
                      autoUpload: "",
                      showFileList: "",
                      disabled: "",
                      accept: ['.jpg', '.jpeg', '.png', '.pdf', '.bmp'],
                      limit: 0,
                      limitSize: 2,
                      multiple: false,
                      uploadBtnProps: {
            limitOverHide: true
          },
                      fileList: formData.value.fileList,
                      "onUpdate:fileList": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.fileList) = $event)),
                      onPreview: onFilePreview
                    }, null, 8, ["fileList"]))
                  : (_openBlock(), _createBlock(_unref(BaseInput), {
                      key: 1,
                      disabled: "",
                      type: "textarea",
                      style: {"width":"100%"},
                      placeholder: "请输入",
                      "model-value": "线下提供材料"
                    }))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    })
  ], 64))
}
}

})